import IceMapContainer from "./IceMapContainer";

export default IceMapContainer;